type DiContainerPropType = string;
type DiContainerEntity = unknown;

type DiContainerType = Record<DiContainerPropType, DiContainerEntity>;
const diContainer: DiContainerType = {};

/**
 * Sets values from given object to DI container. Throws if some prop is already there.
 * @param valuesObject
 */
export function setDiValues(valuesObject: Record<DiContainerPropType, DiContainerEntity>) {
    // eslint-disable-next-line no-prototype-builtins
    const existingProp = Object.keys(valuesObject).find(key => diContainer.hasOwnProperty(key));
    if (existingProp) {
        throw new Error(`Dependency "${existingProp}" is already in DI container`);
    }

    Object.assign(diContainer, valuesObject);
}

const containerProxy =
    typeof Proxy !== 'function'
        ? diContainer
        : new Proxy(diContainer, {
              set(target: DiContainerType, p: DiContainerPropType): boolean {
                  throw new Error(`Attempt to directly set "${p}" in DI container`);
              },
              defineProperty(target: DiContainerType, p: DiContainerPropType): boolean {
                  throw new Error(`Attempt to directly define property "${p}" in DI container`);
              },
              isExtensible(): boolean {
                  return false;
              },
              deleteProperty(target: DiContainerType, p: DiContainerPropType): boolean {
                  throw new Error(`Attempt to directly delete property "${p}" in DI container`);
              },
              get(target: DiContainerType, p: DiContainerPropType): unknown {
                  // eslint-disable-next-line no-prototype-builtins
                  if (!target.hasOwnProperty(p))
                      throw new Error(`No property "${p}" found in DI container`);
                  return target[p];
              },
          });

export default containerProxy;
